import { createFileRoute } from '@tanstack/react-router';

import { OnboardingScreen } from '@/auth/OnboardingScreen';

/**
 * Thin route-file shell. The screen component lives at
 * `src/auth/onboarding-screen.tsx`; this file's only job is to
 * register that screen against the `/onboarding` path.
 *
 * Keeping the screen out of `src/routes/` lets TanStack Router's
 * auto-code-splitting plugin lazy-load it cleanly — the plugin warns
 * if a route file also exports the component by name, because that
 * export prevents the file from being split into its own chunk.
 * See `apps/client/docs/design.md` §"Route files are thin shells".
 */

export const Route = createFileRoute('/onboarding')({
  component: OnboardingScreen,
});
